import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Teams moved into the settings (`/settings/teams`). Kept as a redirect for
 * bookmarks and old links.
 */
export const Route = createFileRoute("/_authenticated/dashboard/teams/")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/teams" });
	},
});
